export const PLATFORMS = {
    WINDOWS: 'windows',
    MACOS: 'macos',
    LINUX: 'linux',
};

